import React from "react";
import Card from "components/card";
import {
    Globe,
    Star
} from "lucide-react";
import { Progress } from "antd";

const JobFitCard = ({ role = [] }) => {
    if (!role) return null;

    const { title, description, fit, difficulty } = role;

    const totalStars = 5;

    return (
        <Card className="opacity-100 transform-none">
            <div className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-slate-200 hover:border-slate-300 hover:shadow-md transition-all">
                <div className="pb-6 p-3 sm:p-4">
                    <div className="flex items-start justify-between gap-3 mb-3">
                        <div className="flex-1 min-w-0">
                            <h4 className="font-semibold text-[13px] sm:text-[15px] mb-1">
                                {title}
                            </h4>
                            <div className="space-y-2">
                                <p className="text-[11px] sm:text-[12px] text-slate-700 leading-relaxed">
                                    {description}
                                </p>
                                {fit.trim() === "Challenging" && role.recommendedLocation && (
                                    <div className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-md">
                                        <Globe className="w-3.5 h-3.5 flex-shrink-0" />
                                        <span className="font-semibold text-[11px] sm:text-[12px]">
                                            Recommended location: {role.recommendedLocation}
                                        </span>
                                    </div>
                                )}
                            </div>  
                        </div>
                        <span
                            className={`inline-flex items-center justify-center rounded-xl px-2 py-0.5 font-medium w-fit shrink-0 gap-1 border-transparent 
                                ${
                                fit.trim() === "Excellent fit" || fit.trim() === "Strong fit"
                                    ? "text-green-600 bg-green-100"
                                    : fit.trim() === "Viable"
                                    ? "text-yellow-600 bg-yellow-100"
                                    : "text-orange-600 bg-orange-100"
                                } whitespace-nowrap text-[10px] sm:text-[11px]`}
                            >
                            {fit}
                        </span>
                    </div>
                    <div className="space-y-2">
                        <div className="flex items-center justify-between text-[11px] sm:text-[12px]">
                            <span className="text-slate-700">
                                Sourcing Difficulty
                            </span>
                            <div className="flex items-center gap-1">
                               {Array.from({ length: totalStars }).map((_, index) => (
                                    <Star
                                        key={index}
                                        className={`w-3 h-3 sm:w-4 sm:h-4 ${
                                            index < difficulty
                                                ? "fill-yellow-400 text-yellow-400"
                                                : "fill-white text-slate-300"
                                        }`}
                                    />
                                ))}
                            </div>
                        </div>
                        <Progress
                            percent={(difficulty / 5) * 100}
                            showInfo={false}
                            strokeColor="#10b981"
                            strokeWidth={8} 
                            trailColor="rgba(16, 185, 129, 0.2)" 
                            className="!m-0 !h-2 !rounded-full"
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default JobFitCard;